import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, BehaviorSubject, of} from 'rxjs';
import {environment} from '@env/environment';
import {ConstantsService} from '@app/services/constants/constants.service';
import {catchError, retry} from 'rxjs/operators';
import {BackendResponse} from "@app/interfaces/backendResponse";

export interface Task {
    id: number;
    title: string;
    description: string;
}

@Injectable({
    providedIn: 'root'
})
export class TaskService {

    private apiURL = environment.apiURL;
    taskType = '';
    taskTitle: string;
    taskProject: any;
    taskTags = [];
    taskDescription: any;
    taskAssigned = [];
    taskEstimate: any;
    taskDeadline: any;
    subtasks = [];
    assignedValidation: boolean;
    validatorValidation: boolean;
    validProject: boolean;


    public taskCreated = new BehaviorSubject<string>(null); //kad se doda task da se u pozadini poziva funkcija za reload tih taskova (npr sastanaka)

    eye = false;
    public watchingButtonShow = new BehaviorSubject<boolean>(this.eye);

    watcher = false;
    public watcherInit = new BehaviorSubject<boolean>(this.watcher);

    public statusInit = new BehaviorSubject<boolean>(false); // nakon sto se zaustavi opcija play, da to vrijeme koje je izracunato se pretvori u aktivnost


    attachments = [];
    validators = [];

    httpOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
        })
    };

    constructor(private httpClient: HttpClient,
                private constants: ConstantsService) {
    }

    buttonChange(data) {
        this.watchingButtonShow.next(data);
    }

    nextValueWatcher(newData: any) {
        this.watcherInit.next(newData);
    }


    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            
            return of(result as T);
        };
    }

    getAll() {
        let params = new HttpParams()
            .set('creator', this.constants.creator_id);
        return this.httpClient.get(this.apiURL + '/task/getAll', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getAll')));

    }

    getTaskData(id) {
        let params = new HttpParams()
            .set('taskId', id);
        return this.httpClient.get<Task[]>(this.apiURL + '/task/get', {params});
    }

    getComments(taskId) {
        let params = new HttpParams().set('task_id', taskId);
        return this.httpClient.get<any>(this.apiURL + '/task/getComments', {params: params});
    }

    addComment(taskId, textComment, sort, attachments?) {
        let params = new HttpParams()
            .set('creator', this.constants.getLoggedInUserId().toString())
            .set('task_id', taskId)
            .set('comment', textComment)
            .set('sort', sort)
            .set('attachments', JSON.stringify(attachments));
        return this.httpClient.post<BackendResponse>(this.apiURL + '/task/addComment', params);
    }

    addActivity(activityObject, mode) {

        let params = new HttpParams()
            .set('creator', this.constants.creator_id)
            .set('mode', mode)
            .set('activityObject', JSON.stringify(activityObject));
        return this.httpClient.get<any>(this.apiURL + '/task/addActivity', {params: params});
    }

    getActivities(creatorId) {

        let params = new HttpParams()
            .set('creator', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/getActivities', {params: params});
    }

    deleteActivity(activityId) {

        let params = new HttpParams()
            .set('activityId', activityId);
        return this.httpClient.get<any>(this.apiURL + '/task/deleteActivity', {params: params});
    }


    // Live view items

    getLiveViewItems(creatorId) {

        let params = new HttpParams()
            .set('creator', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/getLiveViewItems', {params: params});
    }


    saveTask(data) {
        let params = {
            data: JSON.stringify(data),
            creator_id: this.constants.creator_id
        };
        return this.httpClient.post<any>(this.apiURL + '/task/saveTask', params
        );
    }


    getProjects() {
        return this.httpClient.get<any>(this.apiURL + '/task/getProjects');
    }


    getTomorrowMeetings() {

        let params = new HttpParams()
            .set('creator', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/getTomorrowMeetings', {params: params});
    }

    getReminders() {
        let params = new HttpParams()
            .set('creator', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/getReminders', {params: params});
    }

    getNotes() {
        let params = new HttpParams()
            .set('creator', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/getNotes', {params: params});
    }

    setWathcer(data) {
        let params = new HttpParams()
            .set('creator', this.constants.creator_id)
            .set('data', data);
        return this.httpClient.get<any>(this.apiURL + '/task/setWatcher', {params: params});
    }

    removeWatcher(data) {
        let params = new HttpParams()
            .set('creator', this.constants.creator_id)
            .set('data', JSON.stringify(data));
        return this.httpClient.get<any>(this.apiURL + '/task/removeWatcher', {params: params});
    }

    changeStatusOfTask(data) {
        let params = new HttpParams()
            .set('status', data['status'])
            .set('task', data['task'])
            .set('user_id', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/changeStatusOfTask', {params: params});
    }

    getWatcherInfo(data) {
        let params = new HttpParams()
            .set('creator', this.constants.creator_id)
            .set('task_id', data);
        return this.httpClient.get<any>(this.apiURL + '/task/getWatcherInfo', {params: params});
    }

    getSubtasks(taskId) {
        let params = new HttpParams()
            .set('task_id', taskId);
        return this.httpClient.get<any>(this.apiURL + '/task/getSubtasks', {params: params});
    }

    deleteTask(id) {
        return this.httpClient.post<any>(this.apiURL + '/task/deleteTask', {id: id});
    }

    deleteSubtask(id) {
        const params = new HttpParams()
            .set('id', id);
        return this.httpClient.get<any>(this.apiURL + '/task/deleteSubtask', {params: params});
    }

    changeStatusTask(status, id) {
        const params = new HttpParams()
            .set('id', id)
            .set('status', status);
        return this.httpClient.get<any>(this.apiURL + '/task/changeStatusTask', {params: params});
    }


    getAllWatchingTasksByUser() {
        const params = new HttpParams()
            .set('id', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/getAllWatchingTasks', {params: params});
    }


    getAssignedTasks() {
        const params = new HttpParams()
            .set('user_id', this.constants.creator_id);
        return this.httpClient.get<any>(this.apiURL + '/task/getAllAssignedTasks', {params: params});
    }

    getTaskDurationRequest(data){
      const params = new HttpParams()
        .set('_id', data['_id'])
        .set('sort', data['sort']);
      return this.httpClient.get<any>(this.apiURL + '/task/getTaskDurationRequest', {params: params});
    }

    getTaskDuration(task) {
        const params = new HttpParams()
            .set('task', JSON.stringify(task));
        return this.httpClient.get<any>(this.apiURL + '/task/getTaskDuration', {params: params});
    }

    validateTask(data) {
        return this.httpClient.post<any>(this.apiURL + '/task/validateTask', data).pipe(
        );
    }

    getActivitiesForToday() {
        const data = {
            id: this.constants.creator_id
        };
        return this.httpClient.get<any>(this.apiURL + '/task/getActivitiesForToday', {params: data});
    }


    getTasksForValidation() {
        const data = {
            id: this.constants.creator_id
        };
        return this.httpClient.get<any>(this.apiURL + '/task/getTasksForValidation', {params: data});
    }

    getRecentNotifications() {
        const data = {
            id: this.constants.creator_id
        };
        return this.httpClient.get<any>(this.apiURL + '/task/getRecentNotifications', {params: data});
    }

    postponeTask(data) {
        return this.httpClient.get<any>(this.apiURL + '/task/postponeTask', {params: data});
    }


    taskDuration(type, task) {
        const params = new HttpParams()
            .set('type', type)
            .set('task', JSON.stringify(task));
        return this.httpClient.post<any>(this.apiURL + '/task/taskDuration', params);
    }


    taskChange(data) {
        const params = new HttpParams()
            .set('data', JSON.stringify(data));
        return this.httpClient.post(this.apiURL + '/task/taskChange', params);
    }

    getTaskTypes() {

        return this.httpClient.get(this.apiURL + '/task/getTaskTypes');
    }

    addTaskType(data) {
        const params = new HttpParams()
            .set('data', data);
        return new Promise((resolve, reject) => {
            this.httpClient.post(this.apiURL + '/task/addTaskType', params).toPromise().then(result => {
                resolve(result);
            }, (err) => {
                
                reject(err);
            });
        });
    }

    closeNotification(id) {
        const params = new HttpParams()
            .set('id', id)
            .set('user_id', this.constants.creator_id);
        return this.httpClient.get(this.apiURL + '/task/closeNotification', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('closeNotification')));
    }

    generateTaskNumber(sort, taskId?: string, taskNumber ?: string) {
        const params = new HttpParams()
            .set('sort', sort)
            .set('task_id', taskId)
            .set('taskNumber', taskNumber);
        return this.httpClient.get(this.apiURL + '/task/generateTaskNumber', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('generateTaskNumber')));
    }

    getDecodedId(data) {
        const params = new HttpParams().set('data', data);
        return this.httpClient.get(this.apiURL + '/task/getId', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getId')));
    }

    getTaskHistory(id) {
        let params = new HttpParams().set('id', id);
        return this.httpClient.get(this.apiURL + '/task/getTaskHistory', {params: params})
            .pipe(retry(1),
                catchError(this.handleError('getTaskHistory')));
    }


}
